import { render, staticRenderFns } from "./RecipePreview.vue?vue&type=template&id=6d5a6196"
import script from "./RecipePreview.vue?vue&type=script&lang=js"
export * from "./RecipePreview.vue?vue&type=script&lang=js"
import style0 from "./RecipePreview.vue?vue&type=style&index=0&id=6d5a6196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports